import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import Backend from 'i18next-xhr-backend'
// not like to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
import de from './de/translation.json'
import en from './en/translation.json'
// import ar from './ar/translation.json'
import es from './es/translation.json'
import fr from './fr/translation.json'
import el from './el/translation.json'
import it from './it/translation.json'
import pt from './pt/translation.json'
import tr from './tr/translation.json'

import 'dayjs/locale/de'
import 'dayjs/locale/en'
import 'dayjs/locale/ar'
import 'dayjs/locale/el' // gr, greek
// import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/it'
import 'dayjs/locale/pt'
import 'dayjs/locale/tr'

import dayjs from 'dayjs'
import { defaultLocale } from './config'
import { INVOICE_ITEM_ADDITION } from '../constants'
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector'

dayjs.extend(require('dayjs/plugin/localizedFormat'))

// key must match a shortLocale in ../locales.js for CountrySelect
const resources = {
  // ar: {
  //   translation: ar
  // },
  de: {
    translation: de
  },
  en: {
    translation: en
  },
  es: {
    translation: es
  },
  fr: {
    translation: fr
  },
  el: {
    translation: el
  },
  it: {
    translation: it
  },
  pt: {
    translation: pt
  },
  tr: {
    translation: tr
  }
}

const DETECTION_OPTIONS = {
  order: ['querystring', 'localStorage', 'defaultLanguageDetector'],
  caches: ['localStorage'],
  lookupQuerystring: 'lang',
}

const languageDetector = new I18nextBrowserLanguageDetector()
languageDetector.addDetector({
  name: 'defaultLanguageDetector',
  lookup () {
    return defaultLocale
  },
  cacheUserLanguage () {},
})

i18n
  // load translation using xhr -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  .use(I18nextBrowserLanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    // lng: defaultLocale,
    detection: DETECTION_OPTIONS,
    fallbackLng: defaultLocale,
    supportedLngs: Object.keys(resources),
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
      format: function (value, rawFormat, lng) {
        const [format, ...additionalValues] = rawFormat.split(',').map((v) => v.trim())
        switch (format) {
          case 'format_price':
            return Intl.NumberFormat(lng, {
              style: 'currency',
              currency: additionalValues[0]
            }).format(value)
          case 'invoice_item_with_addition':
            let label = additionalValues[0]
            if (value && value.hasOwnProperty('type') && value.type === INVOICE_ITEM_ADDITION.percent) {
              label += ' (' + value.value * 100 + '%)'
            }
            return label
          default:
            return value
        }
      }
    }
  })

export default i18n
